"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.assert = assert;
exports.ConnectError = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _errorsUtils = require("errors-utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var ConnectError = /*#__PURE__*/function (_createNamespaceError) {
  (0, _inherits2["default"])(ConnectError, _createNamespaceError);

  var _super = _createSuper(ConnectError);

  function ConnectError() {
    (0, _classCallCheck2["default"])(this, ConnectError);
    return _super.apply(this, arguments);
  }

  return ConnectError;
}((0, _errorsUtils.createNamespaceError)('3IC'));

exports.ConnectError = ConnectError;

function assert(condition, code, message) {
  return (0, _errorsUtils.assertAs)(condition, ConnectError, code, message);
}

assert.isDefined = function (value, message) {
  return assert(value != null, 2, message);
};

assert.isString = function (value) {
  var message = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'Input must be a string';
  return assert(typeof value === 'string', 3, message);
};